import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-profile-dropdown',
  templateUrl: './profile-dropdown.component.html',
  styleUrls: ['./profile-dropdown.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileDropdownComponent {
  private translocoService = inject(TranslocoService);
  private elementRef = inject(ElementRef);

  showMenu = signal(false);

  activeLang = () => this.translocoService.getActiveLang();

  toggleMenu = () => {
    this.showMenu.update(v => !v);
  };

  selectLanguage = (lang: string) => {
    this.translocoService.setActiveLang(lang);
    this.showMenu.set(false);
  };

  @HostListener('document:click', ['$event'])
  onClickOutside = (event: Event) => {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showMenu.set(false);
    }
  };
}
